const customHostname = '/jas'
const publicRoute = path => window.location.pathname.includes('ulbsibiu') ? `${customHostname}${path}` : path

export { publicRoute }